exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".descriptionModule[data-v-659c1858]{min-height:50px;padding:20px;background:#f2f2f2;font-family:Roboto,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-659c1858","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/codeModules/moduler.vue
// module id = 485
// module chunks = 0